import { Component, Input } from '@angular/core';
import { StandaloneDefaultImports } from 'src/app/shared/ui/standalone-default-imports';
import { kendoTooltipsDefaultImports } from 'src/app/shared/ui/kendo-default-imports';
import { AvatarComponent, PopoverValidPositions } from '../avatar/avatar.component';

@Component({
    selector: 'user-avatar',
    imports: [...StandaloneDefaultImports, ...kendoTooltipsDefaultImports, AvatarComponent],
    templateUrl: './user-avatar.component.html'
})
export class UserAvatarComponent {
    // Section: PUBLIC PROPERTIES
    //----------------------------------------------------------------------
    @Input() user: any;
    @Input() small?: boolean = false;
    @Input() medium?: boolean = false;
    @Input() anonymous?: boolean;
    @Input() showPopover?: boolean;
    @Input() popoverPosition?: PopoverValidPositions = 'bottom';
    @Input() shortVersion?: boolean;
    @Input() showUsername?: boolean = false;
    @Input() hideName?: boolean;
}
